// extracted by mini-css-extract-plugin
export var editButton = "_nx-0";